module.exports = __webpack_public_path__ + "static/media/bookmark-fav-dynamic-color.d1b06045.png";